// extracted by mini-css-extract-plugin
module.exports = {"section":"offset-section_section__2bsW8","container":"offset-section_container__Lm3yB"};